import { lazy } from 'react'
import LoadingPage from './loading'
import LoadingTest from './loading-test'
import Splash from './splash'
import SplashSplit from './splash-split'
import Testing from './testing'
import TestingCards from './testing-cards'
import TestingPopupLayer from './testing-popup-layer'
import TestingCork from './testing-popup-cork'
import Map from './map-actions'
import AudioIntro from './audio-intro'
import ProductDetailPage from './product-detail'
import MenuCardsPage from './menu-cards'
import CollectionDetailPage from './collection-detail'

export {
  LoadingPage,
  LoadingTest,
  Testing,
  TestingCards,
  TestingPopupLayer,
  TestingCork,
  Splash,
  SplashSplit,
  AudioIntro,
  Map,
  ProductDetailPage,
  MenuCardsPage,
  CollectionDetailPage
}

export const VRPage = lazy(() => import('./vr'))
export const PanoramasPage = lazy(() => import('./panoramas'))
export const ProcessesPage = lazy(() => import('./processes'))
export const ProductsPage = lazy(() => import('./products'))
export const AmorimGroupPage = lazy(() => import('./amorim-group'))
